const getter = {
  userInfo: (state) => state.user.userInfo,
  isVip: (state) => state.user.userInfo.vip,
  coinName: () => '金币',
  popRechargeDCountDownTime: (state) => state.abPop.popRechargeDCountDownTime,
  rechargeProps: (state) => state.abPop.rechargeProps,
  referer: (state) => state.common.referer,
  currentPage: (state) => state.common.currentPage,
  appInit: (state) => state.common.appInit
}

export default getter
